// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"99":"Polygonizer","163":"OLparser","239":"lineSplit","553":"UnionOp","644":"BufferOp"}[chunkId] || chunkId) + ".bundle.js";
};